export default "__VITE_ASSET__BYUSCGGI__"